<footer class="footer">
    <div class="row footer-color py-3 m-0" style="font-size: 14px;">
        <div class="col-12  col-md-4 m-0">
            <div class="p-3 text-white text-center">
                <span> {{ 'MAS_GARANTIA_FOOTER.LABEL1' | translate }} </span><span style="white-space:nowrap;"> {{ 'MAS_GARANTIA_FOOTER.LABEL2' | translate }} </span>
            </div>
        </div>
        <div class="col-12  col-md-4 m-0">
            <div class="p-3 text-white text-center"
            [innerText]="'Comentarios y sugerencias: atencion@liverpool.com.mx'">
            </div>
        </div>
        <div class="col-12 col-md-4 m-0">
            <div class="p-3 text-white text-center">
                <a class="text-decoration-none text-reset"
                    href="https://pif.liverpool.com.mx/condiciones-generales"> {{ 'MAS_GARANTIA_FOOTER.LABEL3' | translate }} </a> {{ 'MAS_GARANTIA_FOOTER.LABEL4' | translate }} 
                <a
                    class="text-decoration-none text-reset"
                    routerLink="privacy-policy"> {{ 'MAS_GARANTIA_FOOTER.LABEL5' | translate }} </a>
                 <!--   <app-language-plugin class="d-flex justify-content-end pt-4"></app-language-plugin>-->
            </div>        
        </div>
    </div>
    <div class="row footer-color2 py-2 m-0" style="font-size: 11px;">
        <div class="col">
            <div class="text-white text-center">
                <div class="p-3"> {{ 'MAS_GARANTIA_FOOTER.LABEL6' | translate }} </div>
            </div>
        </div>
    </div>
</footer>